import React from 'react';
import PropTypes from 'prop-types';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';

export function CompareAd({ isMobile = false, position = '1', ...restProps }) {
  const adname = isMobile ? 'mcompare' : 'compare';
  return (
    <div className="compare-ad d-none">
      <AdUnit
        adName={adname}
        position={position}
        all
        renderWhenViewable={false}
        refreshable={false}
        showLabel={false}
        isMobile={isMobile}
        {...restProps}
      />
    </div>
  );
}

CompareAd.propTypes = {
  isMobile: PropTypes.bool,
  position: PropTypes.string,
};
